// extracted by mini-css-extract-plugin
export var downArrow = "_gu-0";
export var infoTooltipIcon = "_gu-3";
export var label = "_gu-1";
export var optionCard = "_gu-4";
export var upArrow = "_gu-2";